export default __webpack_public_path__ + "static/media/1868.aaaf7d8e.png";